import { RootState } from 'src/redux/createRootReducer'
import { ErrorDetailMap } from 'src/utils/error.utils'

export const selectIsPostingUserFromState = (state: RootState): boolean =>
  state.app.signup.isPostingUser
export const selectTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.signup.topLevelError
export const selectErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined => state.app.signup.errorDetailMap
export const selectUserEmailVerifiedFromState = (state: RootState): boolean =>
  state.app.signup.userEmailVerified
export const selectVerificationEmailResentFromState = (
  state: RootState,
): boolean => state.app.signup.verificationEmailResent
export const selectVerificationPhoneResentFromState = (
  state: RootState,
): boolean => state.app.signup.verificationPhoneResent
export const selectVerificationPhoneLoadingFromState = (
  state: RootState,
): boolean => state.app.signup.verifyPhoneVerificationLoading
export const selectIsVerifyingUserFromState = (state: RootState): boolean =>
  state.app.signup.isVerifyingUser
export const selectResendVerificationTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.signup.resendVerificationTopLevelError
export const selectVerifyEmailTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.signup.verifyEmailTopLevelError
export const selectVerifyPhoneTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.signup.verifyPhoneTopLevelError
